package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp

internal val ColIndex = 56.dp
internal val ColStudent = 320.dp
internal val ColMark = 112.dp
internal val HeaderH = 132.dp
internal val RowH = 68.dp
internal val HeaderBlockPadV = 6.dp
/** Gap between session groups (посещ + ДЗ) so they read as clusters. */
internal val SessionGroupGap = 28.dp
internal val SessionAccent = Color(0xFF14B8A6)
